import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_MOST_DOWNLOADED_PRODUCTS_FOR_SITE } from "../graphql/queries";

// eslint-disable-next-line import/prefer-default-export
export const useGetMostDownloadedProductsForSite = ({ siteId, limit }) => {
  const [mostDownloadedProducts, setMostDownloadedProducts] = useState([]);

  const { data, loading, error, refetch } = useQuery(
    GET_MOST_DOWNLOADED_PRODUCTS_FOR_SITE,
    {
      variables: {
        siteId,
        limit,
      },
      skip: !siteId,
    }
  );

  useEffect(() => {
    refetch();
  }, [siteId, limit]);

  useEffect(() => {
    if (loading || error) {
      setMostDownloadedProducts([]);
      return;
    }

    if (data && data.widgets && data.widgets.getMostDownloadedProductsForSite) {
      const { getMostDownloadedProductsForSite = [] } = data.widgets;
      setMostDownloadedProducts(getMostDownloadedProductsForSite);
    }
  }, [data, loading, error]);

  return { refetch, mostDownloadedProducts, loading, error };
};
